import { useState } from "react"
import { toast } from 'react-hot-toast';
import ajaxChargeRate from "../../../util/remote/ajaxChargeRate";
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";


const UpdateCanteenDepositRange=(props)=>{

    const [loading, setLoading] = useState(false)
    const [minAmount, setMinAmount] = useState(props.minAmount)
    const [maxAmount, setMaxAmount] = useState(props.maxAmount)
    const [charge, setCharge] = useState(props.charge)
    const [secureString, setSecureString] = useState("")

  const data = 
  {
    range_id: props.rangeID,
    min_amount: minAmount,
    max_amount: maxAmount,
    charge_rate: charge,
    secure_string: secureString
  };

  const handleUpdate = async(e) =>
  {
    e.preventDefault()
    setLoading(true)
    const server_response = await ajaxChargeRate.updateCanteenDepositRate(data);
    setLoading(false);
    if(server_response.status==="OK"){
      toast.success(server_response.message);
      props.g();
    }
    else{
      toast.error(server_response.message); 
    } 
  }
    
  const RenderFooter=(controls)=>{

    if(loading){
      return <Loader/>
    }else{

      return <> 
        <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
        <button 
          type="button" 
          className={`btn-fill-md text-light bg-dodger-blue`} 
          onClick={handleUpdate}>Save Changes<i class="fas fa-check mg-l-15"></i></button>
      </>
    }
  }

  return(
    <SystemModal
      title="Update Canteen Deposit Range"
      id="model-update-dep-range"
      size="md"
      footer={RenderFooter}
    >

    <div className="row">
            <div className="col-xl-6 col-lg-6 col-12 form-group">
               <label htmlFor="">Minimum Amount</label>
               <input type="text" value={minAmount} onChange={(e)=>setMinAmount(e.target.value)} className="form-control"/>
            </div>

             <div className="col-xl-6 col-lg-6 col-12 form-group">
               <label htmlFor="">Maximum Amount</label>
                <input type="text" value={maxAmount} onChange={(e)=>setMaxAmount(e.target.value)} className="form-control"/>
             </div>
        </div>

    <div className="row">
            <div className="col-xl-6 col-lg-6 col-12 form-group">
               <label htmlFor="">Deposit Charge</label>
               <input type="text" value={charge} onChange={(e)=>setCharge(e.target.value)} className="form-control"/>
            </div>

             <div className="col-xl-6 col-lg-6 col-12 form-group">
               <label htmlFor="">Admin Password</label>
                <input type="password" value={secureString} onChange={(e)=>setSecureString(e.target.value)} className="form-control"/>
             </div>
        </div>
       
        </SystemModal>
    )
}

export default UpdateCanteenDepositRange
